import { Arguments } from '@buderus-apps/components'



const args = new Arguments('ai-search-app-root', {
  assetsUrl: process.env.PUBLIC_URL,
  apiUrl: undefined,
  csrfToken: undefined,
  siteId: process.env.REACT_APP_CONFIG ?? '',
  privacyLink: process.env.REACT_APP_CONFIG ?? '',
  termsOfUseLink: process.env.REACT_APP_CONFIG ?? ''
})
export default args
